
/**
 * Loads the helptext from s3
 * //Note we'd prefer to use cloudfront but have issues with CORS config
 */
angular.module('qkr').factory('helpService', ($rootScope, appConfig, utils, $http) => ({
        helpText: {content: null},
        loadingHelp: false,
        loadingFailed: false,
        helpLoaded: false,
        loadHelp() {
            const self = this;
            try {
                if (!self.loadingHelp && !self.loadingFailed) {
                    self.loadingHelp = true;

                    if ('withCredentials' in new XMLHttpRequest()) {
                        // Supports CORS cross-domain requests

                        return $http.get('https://qkr.azureedge.net/img/mss/help.json', {withCredentials: false}).then((response) => {
                            self.loadingHelp = false;
                            self.helpText.content = angular.copy(response.data);
                            self.helpLoaded = true;

                            $rootScope.$broadcast('HelpLoaded');

                            return response.data;
                        }, () => {
                            self.loadingFailed = true;
                            self.loadingHelp = false;
                        });
                    } else {
                        // If CORS not supported (IE8 and IE9), need to proxy through our server

                        return $http.get('../aws/', {params: {path: '/qkr/mss/help.json'}, withCredentials: false}).then((response) => {
                            self.loadingHelp = false;
                            self.helpText.content = angular.copy(response.data);
                            self.helpLoaded = true;

                            $rootScope.$broadcast('HelpLoaded');

                            return response.data;
                        }, () => {
                            self.loadingFailed = true;
                            self.loadingHelp = false;
                        });
                    }
                }
            } catch (e) {
                console.error(e);
            }
        },
        tooltip(pageName) {
            return this.answer(pageName);
        },
        question(pageName) {
            if (this.helpText.content == null) {
                this.loadHelp();
                return '';
            }
            let res = '';

            const x = this.helpText.content[pageName];
            if (x != null) {
                res = '' + x.Question + '';
            } else
                res = 'Coming soon...';
            return res;
        },
        answer(pageName) {
            if (this.helpText.content == null) {
                this.loadHelp();
                return '';
            }
            let res = '';

            const x = this.helpText.content[pageName];
            if (x != null) {
                res = '' + x.Answer + '';
            } else
                res = 'Coming soon...';
            return res;
        },
        getHtmlForNode(x) {
            return '<b>' + x.Question + '</b><br />' + x.Answer + '<br /><br />';
        },
        getHelpMsg(pageName) {
            if (this.helpText.content == null) {
                this.loadHelp();
                return;
            }
            let res = '';
            const x = this.helpText.content[pageName];
            if (x != null) {
                if (!utils.hasNoValue(x.Question)) {
                     res += this.getHtmlForNode(x);
                }
                if (!utils.hasNoValue(x.Related)) {
                    const rel = x.Related.split(',');
                    for (let i = 0; i < rel.length; i++) {
                        const thisEl = rel[i].trim();
                        const child = this.helpText.content[thisEl];
                        if (!utils.hasNoValue(child))
                        res += this.getHtmlForNode(child);
                    }
                }
                return res;
            }

            return 'Coming soon...';
        },
        getVideoTutorials() {
        	return $http.get(appConfig.apiUrl + 'videoTutorial/list', {withCredentials: true}).then((response) => response.data);
        },
        getVideoTutorialsByCategory(category) {
        	return $http.get(appConfig.apiUrl + 'videoTutorial/getVideoTutorialsByCategory/' + category, {withCredentials: true}).then((response) => response.data);
        },
        getVideoTutorialsByCategoryAndGroup(category, group) {
        	const videoTutorialCategoryAndGroupCommand = {
        		category,
        		group
        	};
        	
        	return $http.post(appConfig.apiUrl + 'videoTutorial/getVideoTutorialsByCategoryAndGroup', videoTutorialCategoryAndGroupCommand, {withCredentials: true}).then((response) => response.data);
        },
        getResource(){
            return $http.get(appConfig.apiUrl + 'resource/list', {withCredentials: true}).then((response) => response.data);
        },
        getResourceByCategory(category){
            return $http.get(appConfig.apiUrl + 'resource/getResourceByCategory/' + category, {withCredentials: true}).then((response) => response.data);
        },
        getResourceByCategoryAndGroup (category, group){
            const resourceCategoryAndGroupCommand = {
                category,
                group
            };
            return $http.post(appConfig.apiUrl + 'resource/getResourceByCategoryAndGroup', resourceCategoryAndGroupCommand, {withCredentials: true}).then((response) => response.data);
        },
}));




// WEBPACK FOOTER //
// ./src/services/helpService.js